import DataV2 from 'common/DataV2';

import type { Dispatch, GetState, State } from 'redux-connect';

export const RequestType = 'canny/viewOrders/request';
export const LoadedType = 'canny/viewOrders/loaded';
export const ErrorType = 'canny/viewOrders/error';
export const UpsertType = 'canny/viewOrder/upsert';

export const DefaultGroupID = 'default';

export type RequestViewOrderAction = Action & {
  type: typeof RequestType;
  groupID: string;
};

export type LoadedViewOrderAction = Action & {
  type: typeof LoadedType;
  groupID: string;
  viewOrder: string[];
};

export type ErrorViewOrderAction = Action & {
  type: typeof ErrorType;
  groupID: string;
  error: string;
};

export type UpsertViewOrderAction = Action & {
  type: typeof UpsertType;
  groupID: string;
  viewOrder: string[];
};

function requestAction(groupID: string): RequestViewOrderAction {
  return {
    type: RequestType,
    groupID,
  };
}

function loadedAction(groupID: string, viewOrder: string[]): LoadedViewOrderAction {
  return {
    type: LoadedType,
    groupID,
    viewOrder,
  };
}

function errorAction(groupID: string, error: string): ErrorViewOrderAction {
  return {
    error,
    type: ErrorType,
    groupID,
  };
}

function upsertAction(groupID: string, viewOrder: string[]): UpsertViewOrderAction {
  return {
    type: UpsertType,
    groupID,
    viewOrder,
  };
}

function fetchViewOrder(groupID: string) {
  return async (dispatch: Dispatch, getState: GetState) => {
    const cookies = getState().cookies;
    try {
      const response = await DataV2.fetch(
        DataV2.queries.viewOrder,
        { groupID: groupID === DefaultGroupID ? null : groupID },
        cookies,
      );
      return dispatch(loadedAction(groupID, response.viewOrder));
    } catch (error) {
      if (typeof error === 'string') {
        return dispatch(errorAction(groupID, error));
      }
      return dispatch(errorAction(groupID, 'server error'));
    }
  };
}

export function loadViewOrder(groupID: string | null) {
  return (dispatch: Dispatch, getState: GetState) => {
    const groupIDToUse = groupID ?? DefaultGroupID;
    if (shouldFetch(getState(), groupID)) {
      dispatch(requestAction(groupIDToUse));
      return dispatch(fetchViewOrder(groupIDToUse));
    }

    return Promise.resolve();
  };
}

export function upsertViewOrder(groupID: string | null, viewOrder: string[]) {
  return (dispatch: Dispatch) => {
    const groupIDToUse = groupID ?? DefaultGroupID;
    dispatch(upsertAction(groupIDToUse, viewOrder));
  };
}

function shouldFetch(state: State, groupID: string | null) {
  const groupIDToUse = groupID ?? DefaultGroupID;
  const viewOrderState = state.viewOrderQueries?.[groupIDToUse];
  return (!viewOrderState || viewOrderState.error) && !viewOrderState?.loading;
}
